import { CaseTypes } from "./../../../types/case/case";
export type SelectFilterOption = {
  label: string;
  value: string;
  customValues?: { [key: string]: string };
};

export enum FilterType {
  "AGENCY" = "AGENCY",
  "STATUS" = "STATUS",
  "CASE_TYPE" = "CASE_TYPE",
  "DATE_RANGE" = "DATE_RANGE",
}

export type FilterProperties = {
  currentValue;
  defaultValue?;
  icon?: string;
  formatter?: (value) => string;
};

export type AppliedFilters = {
  [key in FilterType]?: FilterProperties;
};

export type CaseFilters = {
  agency: string;
  region: string;
  status?: "ALL" | "open" | "closed";
  caseType?: CaseTypes;
  range?: {
    lte: number;
    gte: number;
  };
};



// WEBPACK FOOTER //
// ./src/share/components/Filters/types/index.ts